import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: {
    paddingTop: 10,
    backgroundColor: Colors.white,
  },
  headerStyle: {
    position: 'relative',
  },
  loaderContainer: {
    flex: 1,
    marginBottom: 64,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: {
    width: 150,
    height: 150,
  },
  modalContainer: theme => ({
    paddingHorizontal: 16,
    backgroundColor: theme.colors.backgroundColor
  }),
  icon: {
    alignSelf: 'center',
    marginTop: 24,
    marginBottom: 16,
  },
  description: {
    marginTop: 16,
    marginBottom: 32,
  },
  secondaryButton: {
    marginTop: 16,
    marginBottom: 32,
  },
  modalView: theme => ({
    minWidth: '650px',
    maxWidth: '650px',
    height: 'auto',
    backgroundColor: theme.colors.quickActionGradientColors.secondary,
    margin: 'auto',
    padding: 20,
    borderRadius: "7px",
  })
})

export default styles
